import { validateEducationApi } from '../api/educationApi';

export const requiredEducationHostFields = [
  'useRoute',
  'RouterLink',
  't',
  'registerI18nMessages',
  'getAuthContext',
  'onError',
];

function validateRequiredHostField(host, fieldName) {
  if (!host[fieldName]) {
    throw new Error(`Education module host.${fieldName} is required`);
  }
}

export function validateEducationHostContract(host) {
  if (!host) {
    throw new Error('Education module host is required');
  }

  requiredEducationHostFields.forEach((fieldName) => {
    validateRequiredHostField(host, fieldName);
  });

  if (typeof host.t !== 'function') {
    throw new Error('Education module host.t is required');
  }

  if (typeof host.useRoute !== 'function') {
    throw new Error('Education module host.useRoute is required');
  }

  if (typeof host.registerI18nMessages !== 'function') {
    throw new Error('Education module host.registerI18nMessages is required');
  }

  if (typeof host.getAuthContext !== 'function') {
    throw new Error('Education module host.getAuthContext is required');
  }

  if (typeof host.onError !== 'function') {
    throw new Error('Education module host.onError is required');
  }

  if (host.educationApi) {
    validateEducationApi(host.educationApi, 'Education module host.educationApi');
  }
}
